import { render, staticRenderFns } from "./handItem.vue?vue&type=template&id=49f93a68"
import script from "./handItem.vue?vue&type=script&lang=js"
export * from "./handItem.vue?vue&type=script&lang=js"
import style0 from "./handItem.vue?vue&type=style&index=0&id=49f93a68&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports